import { ReactNode } from 'react';

import { AppFormattedMessage } from '../../components/app-formatted-message/index';
export enum CapTableActivityVariant {
  CUSTOM_DATE = 'custom-date',
  LATEST_CAP_TABLE = 'latest-cap-table',
}

export enum GraphVariant {
  OWNERSHIP = 'ownership',
  VOTING_RIGHTS = 'voting-rights',
}

export const itemsToFetchMap = [5, 10, 20, 50, 100];

export const capTableActivityVariantTitle: Record<CapTableActivityVariant, ReactNode | string> = {
  [CapTableActivityVariant.LATEST_CAP_TABLE]: <AppFormattedMessage id="LATEST_CAP_TABLE" />,
  [CapTableActivityVariant.CUSTOM_DATE]: <AppFormattedMessage id="CUSTOM_DATE" />,
};

export const capTableActivityVariantTitleMap = Object.entries(capTableActivityVariantTitle);

export const latestSnapshotId = 'latest-snapshot';
